(() => {
  'use strict';
  const context = document.getElementById('LXP1Context');
  if (!context || window.LXClarityV2) return;
  const config = context.dataset;
  const params = new URLSearchParams(location.search);
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch (_) {} },
  };
  if (params.get('lx_qa') === '1') storage.set('lx_p1_qa', '1');
  if (params.get('lx_qa') === '0') storage.remove('lx_p1_qa');
  const showQA = params.get('lx_qa') === '1' || (params.get('lx_qa') !== '0' && storage.get('lx_p1_qa') === '1');
  const isProduction = config.themeRole === 'main' && config.designMode !== 'true' &&
    /^(www\.)?lxacrylic\.com$/i.test(location.hostname) &&
    !params.has('preview_theme_id') && !showQA;
  const environment = isProduction ? 'production' : 'qa';
  const prefix = isProduction ? 'lx_v2_' : 'lx_qa_v2_';
  const queue = [];
  let retryTimer;
  let retries = 0;
  let panel;
  let log = [];
  if (showQA) {
    try { log = JSON.parse(storage.get('lx_p1_qa_log') || '[]'); } catch (_) {}
    if (!Array.isArray(log)) log = [];
    panel = document.createElement('details');
    panel.id = 'LXP1QA';
    panel.open = true;
    panel.style.cssText = 'position:fixed;left:8px;bottom:46px;z-index:2147483000;max-width:360px;max-height:200px;overflow:auto;background:#fff;color:#142d35;border:2px solid #167f75;padding:8px;font:12px/1.5 monospace;box-shadow:0 3px 14px #0002';
    const title = document.createElement('summary');
    title.textContent = 'P1 QA · ' + config.currency + ' · theme ' + config.themeId;
    panel.append(title, document.createElement('ol'));
    document.body.append(panel);
  }
  function status(name, delivery) {
    if (!showQA) return;
    log.push({ event: name, status: delivery, time: new Date().toISOString() });
    log = log.slice(-40);
    storage.set('lx_p1_qa_log', JSON.stringify(log));
    const list = panel.querySelector('ol');
    list.replaceChildren(...log.slice(-8).map(entry => {
      const item = document.createElement('li');
      item.textContent = entry.event + ' · ' + entry.status;
      return item;
    }));
  }
  function flush() {
    clearTimeout(retryTimer);
    if (typeof window.clarity !== 'function') {
      if (++retries <= 30) retryTimer = setTimeout(flush, 1000);
      return;
    }
    try {
      window.clarity('set', 'lx_event_schema', 'v2');
      window.clarity('set', 'lx_environment', environment);
      while (queue.length) {
        const name = queue.shift();
        window.clarity('event', name);
        status(name, 'sent to Clarity client');
      }
    } catch (_) {}
  }
  function emit(event) {
    try {
      const name = prefix + event;
      if (queue.length < 40) queue.push(name);
      status(name, 'queued');
      flush();
    } catch (_) {}
  }
  const safe = fn => (...args) => { try { return fn(...args); } catch (_) { return undefined; } };
  window.LXClarityV2 = {
    countryOpened: safe(form => {
      if (form.querySelector('[name="country_code"]')) emit('country_selector_open');
    }),
    rememberCountry: safe((form, target) => {
      if (!form.querySelector('[name="country_code"]') || !/^[A-Z]{2}$/.test(target) || target === config.country) return;
      storage.set('lx_p1_country', JSON.stringify({ target, from: config.country, at: Date.now(), environment }));
    }),
    beginCartAttempt: safe(() => ({ settled: false })),
    cartResult: safe((attempt, response) => {
      if (!attempt || attempt.settled) return;
      attempt.settled = true;
      if (response?.status) { emit('add_to_cart_error'); return; }
      const lines = Array.isArray(response?.items) ? response.items : [response];
      if (lines.length && lines.every(line => line?.id && Number(line.quantity) > 0)) emit('add_to_cart_success');
      else emit('add_to_cart_unverified');
    }),
    cartFailure: safe(attempt => {
      if (!attempt || attempt.settled) return;
      attempt.settled = true;
      emit('add_to_cart_error');
    }),
  };
  // Shopaw uses Axios/XHR and bypasses product-form.js. Its addCartCallback is
  // called after Promise.allSettled, so it is NOT proof of a successful add.
  // Observe only same-origin POST /cart/add responses; preserve request behavior.
  // Native theme fetch requests keep their separate product-form.js hook.
  safe(() => {
    if (typeof window.XMLHttpRequest !== 'function') return;
    const prototype = window.XMLHttpRequest.prototype;
    const open = prototype.open;
    const send = prototype.send;
    const requests = new WeakMap();
    const observed = new WeakSet();
    prototype.open = function(method, url, ...args) {
      const result = open.call(this, method, url, ...args);
      safe(() => {
        const target = new URL(url, location.origin);
        const tracked = String(method).toUpperCase() === 'POST' &&
          target.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(target.pathname);
        requests.set(this, { tracked, attempt: null });
        if (!observed.has(this)) {
          observed.add(this);
          this.addEventListener('load', safe(() => {
            const request = requests.get(this);
            if (!request?.attempt) return;
            if (this.status < 200 || this.status >= 300) {
              window.LXClarityV2.cartFailure(request.attempt);
              return;
            }
            let response;
            try { response = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); } catch (_) {}
            window.LXClarityV2.cartResult(request.attempt, response);
          }));
          for (const event of ['error', 'abort', 'timeout']) {
            this.addEventListener(event, safe(() => window.LXClarityV2.cartFailure(requests.get(this)?.attempt)));
          }
        }
      })();
      return result;
    };
    prototype.send = function(...args) {
      safe(() => {
        const request = requests.get(this);
        if (request?.tracked) request.attempt = window.LXClarityV2.beginCartAttempt();
      })();
      try { return send.apply(this, args); }
      catch (error) {
        safe(() => window.LXClarityV2.cartFailure(requests.get(this)?.attempt))();
        throw error;
      }
    };
  })();
  try {
    const pending = JSON.parse(storage.get('lx_p1_country') || 'null');
    if (pending) {
      storage.remove('lx_p1_country');
      if (pending.environment === environment && Date.now() - pending.at < 120000) {
        emit(pending.target === config.country ? 'country_change_success' : 'country_change_unverified');
      }
    }
  } catch (_) { storage.remove('lx_p1_country'); }
  if (config.page === 'cart') emit('cart_view');
  if (config.page === 'product') emit('product_view');
  let lastCheckout = 0;
  function checkoutClick() {
    const now = Date.now();
    if (now - lastCheckout < 1500) return;
    lastCheckout = now;
    emit('checkout_click');
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const control = target?.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    if (control.matches('[name="checkout"]')) { checkoutClick(); return; }
    try {
      const url = new URL(control.href, location.origin);
      if (url.origin === location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) checkoutClick();
    } catch (_) {}
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.matches('[name="checkout"]')) checkoutClick();
  }, true);
  if (config.page === 'product') {
    const root = document.getElementById('MainContent');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      root?.querySelectorAll('.os-vd__footer-text').forEach(footer => {
        if (footer.textContent !== config.currencyNote) footer.textContent = config.currencyNote;
      });
    };
    if (root) {
      new MutationObserver(() => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      }).observe(root, { childList: true, subtree: true, characterData: true });
      update();
    }
  }
  flush();
})();


